var popupForm = document.getElementById("js-oasis-count-down");
var listid = popupForm?.dataset.listId;
var errorMassage = errorMassage 
var submitButton =  document.querySelector('.submit-btn');
var submittedEmails = new Set(); 

function validateEmail(email) {
  var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
}

popupForm?.addEventListener("submit", function (event) {
  event.preventDefault();
  const formData = new FormData(event.target);
  const formDataJSON = {};
  formData.forEach(function (value, key) {
    formDataJSON[key] = value;
  });
  var email_add = formData.get('contact[email]');
  var name = formData.get('contact[name]');

  if (!validateEmail(email_add)) {
    document.querySelector('.Alert--error').style.display = 'block';
    document.querySelector('.Alert--success').style.display = 'none';
    submitButton.style.display = 'none';
    console.log("validateEmail")
    return; 
  }

  if (submittedEmails.has(email_add)) {
    document.querySelector('.Alert--error').textContent = 'This email has already been submitted.';
    document.querySelector('.Alert--error').style.display = 'block';
    document.querySelector('.Alert--success').style.display = 'none';
    submitButton.style.display = 'none';
    return; 
  }

  const emailList = {
    method: 'POST',
    headers: { revision: '2024-02-15', 'content-type': 'application/json' },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Homepage footer signup form',
          profile: {
            data: {
              type: 'profile',
              id: '01GDDKASAP8TKDDA2GRZDSVP4H',
              attributes: {
                email: email_add,
                first_name: name
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: listid } } }
      }
    })
  };

  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=WPfH8e', emailList)
    .then(response => {
      if (response.ok) {
        document.querySelector('.Alert--success').style.display = 'block';
        document.querySelector('.Alert--error').style.display = 'none';
        submitButton.style.display = 'none'; 
        submittedEmails.add(email_add);
        console.log("ok-response", response)
      } else {
        document.querySelector('.Alert--error').style.display = 'block';
        document.querySelector('.Alert--error').textContent = errorMassage;
        document.querySelector('.Alert--success').style.display = 'none';
        submitButton.style.display = 'none'; 
        console.log("error", response)
      }
    })
    .catch(error => {
      document.querySelector('.Alert--error').style.display = 'block';
      document.querySelector('.Alert--success').style.display = 'none';
      submitButton.style.display = 'none'; 
      console.log("catchcatch", response)
    });
});

popupForm?.addEventListener('input', function () {
  submitButton.style.display = 'flex';
  document.querySelector('.Alert--error').style.display = 'none';
  document.querySelector('.Alert--success').style.display = 'none';
});
